import React from 'react';

const PreloadAnimation = () => {
  return (
    <div id="loader" className="pageload-overlay" data-opening="m -10,-10 0,80 100,0 0,-80 z m 50,-30.5 0,70.5 0,70 0,-70 z">
    	<div className="loader">Loading...</div>
    	<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 80 60" preserveAspectRatio="none" >
    		<path d="m -10,-10 0,80 100,0 0,-80 z M 40,-40.5 120,30 40,100 -40,30 z"/>
    	</svg>
    </div>
  );
}

export default PreloadAnimation;
